module.exports = __webpack_public_path__ + "img/IS.c96909aa.svg";